module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/kibt-fe-shop-c-outside-h5/prod/images/closeWithBackground.a15e7c3629.png";